/* Product reviews renderer.

   The JSON block in sections/product-reviews.liquid is currently empty:
   the 122 reviews that used to be there were written for the store rather
   than by customers and have been removed. This file is kept because the
   renderer itself is fine; it simply has nothing to render until real
   reviews exist.

   Rendering happens client-side, so nothing here reaches search engines
   and no rating schema is emitted. That was a safeguard while the data
   was invented, since none of it could be indexed. With real reviews it
   becomes a cost instead, forfeiting the rich-snippet benefit genuine
   reviews would earn, which is the point at which a proper reviews app
   earns its keep. */
(function () {
  var root = document.querySelector('[data-reviews-section]');
  if (!root) return;

  var dataEl = root.querySelector('[data-reviews-data]');
  var listEl = root.querySelector('[data-reviews-list]');
  if (!dataEl || !listEl) return;

  var all;
  try { all = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!all || !all.length) return;

  var PAGE = 8;
  var moreBtn = root.querySelector('[data-reviews-more]');
  var sortEl = root.querySelector('[data-reviews-sort]');
  var filtersEl = root.querySelector('[data-reviews-filters]');
  var shown = PAGE;
  var filter = 0;

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var cls = i <= Math.floor(n) ? 'is-on' : (n - i + 1 >= 0.25 ? 'is-half' : '');
      out += '<span class="' + cls + '">★</span>';
    }
    return out;
  }

  function when(iso) {
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  function initial(name) { return name.trim().charAt(0).toUpperCase(); }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function current() {
    var rows = filter ? all.filter(function (r) { return r.r === filter; }) : all.slice();
    var mode = sortEl ? sortEl.value : 'recent';
    if (mode === 'high') rows.sort(function (a, b) { return b.r - a.r || (a.d < b.d ? 1 : -1); });
    else if (mode === 'low') rows.sort(function (a, b) { return a.r - b.r || (a.d < b.d ? 1 : -1); });
    else if (mode === 'helpful') rows.sort(function (a, b) { return b.h - a.h || (a.d < b.d ? 1 : -1); });
    else rows.sort(function (a, b) { return a.d < b.d ? 1 : -1; });
    return rows;
  }

  function renderSummary() {
    var sum = all.reduce(function (t, r) { return t + r.r; }, 0);
    var avg = sum / all.length;
    var avgEl = root.querySelector('[data-reviews-avg]');
    var starEl = root.querySelector('[data-reviews-avg-stars]');
    var cntEl = root.querySelector('[data-reviews-count]');
    if (avgEl) avgEl.textContent = avg.toFixed(1);
    if (starEl) starEl.innerHTML = stars(avg);
    if (cntEl) cntEl.textContent = 'Based on ' + all.length + ' reviews';

    /* The compact rating next to the price, up in the buy module. Same
       numbers as the summary above - one calculation, shown twice - so
       reader never has to wonder why they don't match. */
    var heroRating = document.querySelector('[data-product-rating]');
    if (heroRating) {
      var heroStars = heroRating.querySelector('[data-product-rating-stars]');
      var heroAvg = heroRating.querySelector('[data-product-rating-avg]');
      var heroCount = heroRating.querySelector('[data-product-rating-count]');
      if (heroStars) heroStars.innerHTML = stars(avg);
      if (heroAvg) heroAvg.textContent = avg.toFixed(1);
      if (heroCount) heroCount.textContent = all.length + (all.length === 1 ? ' review' : ' reviews');
      heroRating.hidden = false;
    }

    var distEl = root.querySelector('[data-reviews-dist]');
    if (distEl) {
      var html = '';
      for (var s = 5; s >= 1; s--) {
        var n = all.filter(function (r) { return r.r === s; }).length;
        var pct = Math.round((n / all.length) * 100);
        html += '<button type="button" class="reviews__dist-row" data-rate="' + s + '" aria-label="Show only ' + s + ' star">' +
          '<span class="reviews__dist-label">' + s + '★</span>' +
          '<span class="reviews__dist-track"><span class="reviews__dist-fill" style="width:' + pct + '%"></span></span>' +
          '<span class="reviews__dist-n">' + n + '</span></button>';
      }
      distEl.innerHTML = html;
      distEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rate]');
        if (!b) return;
        var v = parseInt(b.getAttribute('data-rate'), 10);
        filter = filter === v ? 0 : v;
        shown = PAGE;
        syncFilters();
        render();
      });
    }
  }

  function syncFilters() {
    if (filtersEl) {
      filtersEl.innerHTML = filter
        ? '<button type="button" class="reviews__chip is-on" data-clear>' + filter + '★ only ×</button>'
        : '';
    }
    root.querySelectorAll('[data-rate]').forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.getAttribute('data-rate'), 10) === filter);
    });
  }

  function render() {
    var rows = current();
    var slice = rows.slice(0, shown);
    listEl.innerHTML = slice.map(function (r) {
      return '<li class="review">' +
        '<div class="review__head">' +
          '<span class="review__avatar" aria-hidden="true">' + esc(initial(r.n)) + '</span>' +
          '<div class="review__who">' +
            '<span class="review__name">' + esc(r.n) +
            '</span>' +
            '<span class="review__meta">' + (r.v ? esc(r.v) + ' · ' : '') + when(r.d) + '</span>' +
          '</div>' +
          '<span class="reviews__stars" aria-label="' + r.r + ' out of 5">' + stars(r.r) + '</span>' +
        '</div>' +
        '<h3 class="review__title">' + esc(r.t) + '</h3>' +
        '<p class="review__body">' + esc(r.b) + '</p>' +
        (r.h ? '<p class="review__helpful">' + r.h + ' found this helpful</p>' : '') +
      '</li>';
    }).join('');

    if (moreBtn) {
      var left = rows.length - slice.length;
      moreBtn.hidden = left <= 0;
      moreBtn.textContent = 'Load ' + Math.min(PAGE, left) + ' more';
    }
  }

  if (moreBtn) moreBtn.addEventListener('click', function () { shown += PAGE; render(); });
  if (sortEl) sortEl.addEventListener('change', function () { shown = PAGE; render(); });
  if (filtersEl) filtersEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-clear]')) { filter = 0; shown = PAGE; syncFilters(); render(); }
  });

  renderSummary();
  syncFilters();
  render();
})();
